import React from 'react';
import { GridProps, Grid } from '@mui/material';
import { defaultGridContainerProps } from 'util/layout';

export const GridContainer: React.FunctionComponent<GridProps> = ({ children, ...props }) => (
  <Grid {...defaultGridContainerProps} {...props}>
    {children}
  </Grid>
);

export default GridContainer;
